"use client";

import React from "react";
import { Box, Stack, useMediaQuery, useTheme } from "@mui/material";
import { FlexibleCard as FlexibleCardType } from "@/types/dto/flexible-card-layout-section";
import FlexibleCard from "../flexible-card";
import CarouselLayout from "./carousel-layout";

interface ZigzagLayoutProps {
  cards: FlexibleCardType[];
}

const ZigzagLayout: React.FC<ZigzagLayoutProps> = ({ cards }) => {
  const theme = useTheme();
  const isDesktop = useMediaQuery((theme as any).breakpoints.up("desktop"));
  
  // Show carousel on tablet and below
  if (!isDesktop) {
    return <CarouselLayout cards={cards} />;
  }
  
  return (
  <Stack 
    className="flexible-card-zigzag-layout"
    spacing={6}
    sx={{
      display: "flex",
      flexDirection: "column",
      alignItems: "stretch"
    }}
  >
    {cards.map((card, idx) => (
      // eslint-disable-next-line react/no-array-index-key
      <Box key={`zigzag-${idx}-${card.tour?.id || "no-tour"}`}>
        <FlexibleCard 
          card={card} 
          reverse={idx % 2 === 1} // Alternate direction on every other card
          index={idx}
        />
      </Box>
    ))}
  </Stack>
  );
};

export default React.memo(ZigzagLayout);